module.exports = __webpack_public_path__ + "img/player-one.21dc583e.png";